import { useState } from "react";
import Pill from "./pill";
import { ImSpinner11 } from "react-icons/im";

export default function Header({ refresh }) {
  const [lastUpdated, setLastUpdated] = useState(null);
  const [refreshing, setRefreshing] = useState(false);

  const handleRefresh = async () => {
    setRefreshing(true);
    await refresh();
    setLastUpdated(new Date());
    setRefreshing(false);
  };

  return (
    <header className="sticky top-0 z-50 h-10 bg-[var(--bg)] border-b border-[var(--bg-lighter)] backdrop-blur-sm shadow-sm">
      <div className="max-w-6xl mx-auto h-full flex items-center justify-between md:py-3 py-4 px-4 md:px-0">
        <div className="flex items-center gap-3">
          <div className="font-serif tracking-wide h-6 w-6 flex items-center justify-center bg-[var(--primary)] rounded-md font-bold text-[var(--bg)] text-lg">
            t
          </div>

          <span className="font-serif tracking-wide font-semibold text-lg text-[var(--foreground)]">
            trilfi
          </span>

          <Pill size="sm" active variant="primary" className="capitalize">
            Markets
          </Pill>
        </div>

        <div className="flex items-center gap-3">
          {lastUpdated && (
            <span className="hidden sm:block text-[var(--foreground-muted)]">
              {refreshing ? (
                <span className="flex items-center gap-1">
                  <span className="spin inline-block border-t-[1.5px] border-[var(--primary-muted)]" />
                  updating
                </span>
              ) : (
                <span className="text-[11px] font-sans font-regular">
                  Updated{" "}
                  <span className="font-nums font-semibold">
                    {lastUpdated.toLocaleTimeString()}
                  </span>
                </span>
              )}
            </span>
          )}

          <button
            className="h-6 w-6 flex items-center justify-center rounded-full bg-[var(--primary-muted)] hover:bg-[var(--primary)] transition-all duration-300"
            onClick={handleRefresh}
          >
            <span className="text-[var(--primary)] hover:text-[var(--background)] flex items-center justify-center">
              <span
                className={`block transition-all duration-300 ${
                  refreshing ? "animate-spin" : ""
                }`}
              >
                <ImSpinner11 size={12} />
              </span>
            </span>
          </button>
        </div>
      </div>
    </header>
  );
}